import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '27rem',
    backgroundColor: theme.palette.container.background,
  },
  loader: {
    margin: 'auto',
  },
}));

export default useStyles;
